// extracted by mini-css-extract-plugin
export default {"deductions-report-header":"LoanMovementReport_deductions-report-header__E1o1s"};